import { lazy } from "react";

import SearchGlobalCorp from "pages/Search/Corporation/View";
import { businessUnitRoutes } from "./entity/businessUnit";
import { communityRoutes } from "./entity/community";
import { corporationRoutes } from "./entity/corporation";
import { kensakuKunRoutes } from "./entity/kensakuKun";
import { personalRoutes } from "./entity/personal";

const Login = lazy(() => import("pages/Login/View"));
const SearchGlobalBU = lazy(() => import("pages/Search/BusinessUnit/View"));
const PersonalGlobalBU = lazy(() => import("pages/Search/Personal/View"));
const PageNotFound = lazy(() => import("pages/404"));
const Landing = lazy(() => import("pages/Landing/View"));

import { RouteType } from "types";
import { routePaths } from "./constants";

export const routes: RouteType[] = [
  ...personalRoutes,
  ...businessUnitRoutes,
  ...corporationRoutes,
  ...communityRoutes,
  ...kensakuKunRoutes,
  {
    path: "/login",
    element: <Login />,
    requiredAuth: false,
    withoutLayout: true,
  },
  {
    path: "/landing",
    element: <Landing />,
    requiredAuth: true,
    withoutLayout: true,
  },
  {
    path: routePaths.root.search.root,
    redirect: routePaths.root.search.personal.root,
    requiredAuth: true,
    superAdminOnly: true,
    element: <PersonalGlobalBU />,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.search.personal.root,
    requiredAuth: true,
    superAdminOnly: true,
    element: <PersonalGlobalBU />,
    label: "personal_account",
  },
  {
    path: routePaths.root.search.bu.root,
    requiredAuth: true,
    superAdminOnly: true,
    element: <SearchGlobalBU />,
    label: "business_unit",
  },
  {
    path: routePaths.root.search.corporation.root,
    requiredAuth: true,
    superAdminOnly: true,
    element: <SearchGlobalCorp />,
    label: "corporation",
  },
  // DEFAULT
  {
    path: "*",
    element: <PageNotFound />,
    requiredAuth: false,
    withoutLayout: true,
  },
];
